import { queryOptions, useQuery } from '@tanstack/react-query'
import { clikArtService } from '@/api/services/clikart.service'
import { queryKeys } from '@/api/query-keys'

/**
 * /clikart/categories returns the ENTIRE ClikArt library (~21MB / ~12,900 items), paged by
 * category group and cached server-side for 24h. It's the only endpoint that can power the
 * gallery's default view (nothing typed/selected) — /clikart/search has no unfiltered mode (see
 * use-clikart-search.ts). `staleTime: Infinity` so this call fires once per session rather than
 * on every panel reopen; the panel additionally windows the result client-side
 * (`useTrayLazyWindow`) rather than rendering every item at once. Shared with
 * `useClikArtCategoriesWarmup`, which sends the same request early so the server cache is warm.
 */
export const clikArtCategoriesQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.clikArt.categories(),
    queryFn: () => clikArtService.getClikArtCategories(),
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
  })

export function useClikArtCategoriesQuery() {
  return useQuery(clikArtCategoriesQueryOptions())
}
